
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
name: "source-question",
props:['sourceDto','isSup'],
data(){
return {
questDetailShow:false,
questionDetail:{}
}
},
directives: {
TransferDom
},
components:{
PopupHeader,
Popup
},
methods:{
viewQuestion(data){
this.$router.push(`/workflow/${data.requestId}?component=WorkflowDynamicFormValueComponent`);
},
supViewQuestion(data){
console.log(data);
this.questionDetail = data;
this.questDetailShow = true;
},
cancelQuestion(){
this.questDetailShow = false;
}
}
}



// WEBPACK FOOTER //
// ./src/page/sources/source-common-module/source-question.vue